<template>
  <section>
    <b-modal :active.sync="isModalActive" has-modal-card :can-cancel="['button']">
      <div class="modal-card modal-sharepoint">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t('config_sharepoint_folder') }}</p>
        </header>
        <section class="modal-card-body">
          <div>
            <sharepoint-explorer @selected-folder="selectedFolder = $event" />
          </div>
          <div>
            <p class="mt-4"><strong>{{ $t('selected_folder') }}: </strong> {{ selectedFolder ? selectedFolder.name :
              'N/A' }}</p>
          </div>
        </section>
        <div class="modal-card-foot">
          <button class="button is-primary" :disabled="!selectedFolder || isLoading"
            v-on:click="saveFolder()"><i class="fas fa-check"></i>&nbsp; {{ $t('save')
            }}</button>
          <button class="button" :disabled="isLoading" v-on:click="isModalActive = false"><i
              class="fas fa-times"></i>&nbsp; {{ $t('close') }}</button>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
  import SharepointExplorer from './sharepoint-explorer.vue'
  import axios from 'axios'
  import EventBus from "~/plugins/bus";
  import { mapGetters } from "vuex";

  export default {

    components: {
      SharepointExplorer
    },

    props: {
      entity: {type: String},
      entityId: {type: Number}
    },

    data() {
      return {
        isModalActive: false,
        isLoading: false,
        selectedFolder: null
      }
    },

    computed: {
      ...mapGetters({
        company: 'app/company',
      }),
    },

    methods: {
      show() {
        this.isModalActive = true
      },

      hide() {
        this.isModalActive = false
      },

      async saveFolder() {
        if (!this.selectedFolder) return
        this.isLoading = true
        let { data } = await axios.post(`/api/v2/sharepoint-key/${this.company.id}/${this.entity}/${this.entityId}/folder`, {
          folder: this.selectedFolder.path
        })
        if (data.success) {
          this.$notify.success('save_successful')
          this.$emit("reload", this.selectedFolder.path)
          this.hide()
        } else {
          this.$notify.error(data.msg)
        }
        this.isLoading = false
      }
    }
}
</script>
<style>
</style>